module.exports = __webpack_public_path__ + "static/media/high_fiber.5ef2064b.png";